
import { createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth-action.types';
import { Auth } from '../model/auth.model';

const initialAuthState: Auth = null;

export const authReducer = createReducer(

  initialAuthState,

  on(AuthActions.Login, (state, auth: Auth) => {
    return ({ ...state, ...auth });
  }),

  on(AuthActions.Logout, () => {
    return initialAuthState;
  })

);
